"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobile = exports.name = void 0;
var bowser_1 = __importDefault(require("bowser"));
var APPLE_MOBILE_DEVICES = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
];
var _a = globalThis.navigator, userAgent = _a.userAgent, platform = _a.platform, maxTouchPoints = _a.maxTouchPoints;
// Vision Pro uniquely supports the WebXR Device API (navigator.xr),
// while iPads and iPhones do not — this is the most reliable discriminator.
// Both Vision Pro and iPads (iPadOS 13+) report 'Macintosh' in the UA
// and have maxTouchPoints > 1, so we cannot rely on those alone.
var isMacLikeWithTouch = userAgent.includes('Macintosh') && maxTouchPoints > 1;
var isVisionOS = isMacLikeWithTouch && 'xr' in globalThis.navigator;
// Detect iOS/iPadOS devices:
// - Older iPads expose 'iPad' in navigator.platform
// - iPadOS 13+ exposes 'MacIntel' but has touch support ('ontouchend' in document)
// - Exclude Vision OS devices which also pass the touch check
var isIOS = !isVisionOS && (APPLE_MOBILE_DEVICES.includes(platform) ||
    (userAgent.includes('Mac') && 'ontouchend' in document));
var bowser = bowser_1.default.getParser(userAgent);
var os = bowser.getOSName().toLowerCase();
var name = isVisionOS ? 'visionos' : isIOS ? 'ios' : os || 'unknown';
exports.name = name;
var isMobile = ['ios', 'android'].includes(name);
exports.isMobile = isMobile;
